import Lookup from 'src/componentes/select-async';
import GatilhoEdit from 'src/paginas/remuneracao-variavel/gatilho/edit';
import GatilhoList from 'src/paginas/remuneracao-variavel/gatilho/view';

const GatilhoLookup = (props) => {
  return (
    <Lookup
      valueKey="id"
      labelKey="nome"
      showSearch
      clearable={true}
      url="/GatilhoLookup"
      editComponent={GatilhoEdit}
      searchComponent={GatilhoList}
      {...props}
    />
  );
};

export default GatilhoLookup;
